import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Dialog as MUIDialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";
import styled from "styled-components";

import { useAlert, useAxios } from "../../hooks";
import { TextField } from "../../components";
import { TextFifteenYellow, colors } from "../css components/Style";
import { CancelButton, PrimaryLoadingButton } from "../css components/Button";

// Styled Dialog override
const StyledDialog = styled(MUIDialog)`
  .MuiDialog-paper {
    min-width: 400px;
  }
`;

export default function AddMoneyDialog({
  setCreditAdded,
  addMoney,
  setAddMoney,
}) {
  const axios = useAxios();
  const { alert } = useAlert();
  const dispatch = useDispatch();

  const { activeBrand, email } = useSelector((state) => state.memberDetails);

  const [amount, setAmount] = useState();
  const [message, setMessage] = useState();

  const handleClose = () => {
    setAddMoney(false);
  };

  useEffect(() => {
    const res = loadScript("https://checkout.razorpay.com/v1/checkout.js");
    if (!res) {
      console.log("Razorpay SDK failed to load. Are you online?");
      return;
    }
    window.onload = () => {
      window.callScript?.();
    };
  }, []);

  return (
    <StyledDialog open={addMoney} onClose={handleClose}>
      <DialogContent>
        <Grid container spacing={8}>
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <TextFifteenYellow style={{ color: colors.green }}>
              Add Credits
            </TextFifteenYellow>
          </Grid>

          <Grid item xs={12}>
            <TextField
              type="number"
              size="small"
              label="Enter Credits"
              placeholder="Enter Credits"
              value={amount}
              onChange={(e) => {
                if (e.target.value.toString().length > 6) {
                  setMessage("You can add credits in lakhs");
                  return;
                }
                if (!isNaN(e.target.value)) {
                  setMessage("");
                  setAmount(e.target.value);
                }
              }}
            />
            {message && (
              <Typography style={{ marginTop: "10px" }} color={colors.error}>
                {message}
              </Typography>
            )}
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions style={{ padding: "24px" }}>
        <PrimaryLoadingButton
          onClick={handlePayment}
          variant="contained"
          color="primary"
          autoFocus
          disabled={parseInt(amount) < 0 || !amount}
        >
          Add Credits
        </PrimaryLoadingButton>

        <CancelButton onClick={handleClose} variant="outlined" color="primary">
          Cancel
        </CancelButton>
      </DialogActions>
    </StyledDialog>
  );

  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  function handlePayment() {
    axios({
      url: "/create/order",
      method: "POST",
      data: {
        receipt: activeBrand?.brandName,
        amount: parseFloat(amount),
        currency: "INR",
        notes: {
          description: activeBrand?.brandName + " payment",
        },
      },
    }).then((response) => {
      if (response.status) {
        handleClose();
        const resp = response.data;

        const options = {
          key: "rzp_test_YvrK73CThtiq9m",
          amount: resp.amount,
          currency: resp.currency,
          order_id: resp.transaction_id,
          name: activeBrand.brandName,
          description: "Please proceed your payment.",
          handler: function (responses) {
            if (responses) {
              axios({
                url: "/verify/order",
                method: "POST",
                data: {
                  order_id: responses.razorpay_order_id,
                  payment_id: responses.razorpay_payment_id,
                  signature: responses.razorpay_signature,
                },
              }).then((verify) => {
                if (verify.status) {
                  setCreditAdded(true);
                  handleClose();
                  dispatch(
                    alert({
                      type: "success",
                      message: "Credits added successfully!",
                    })
                  );
                }
              });
            }
          },
          prefill: {
            email: email,
            phone_number: "7905866225",
          },
        };

        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
      }
    });
  }
}
